// artifacts: всплывающая подсказка подбора — иконка предмета, крупная строка
// («+20 серебра») и подпись («Череп-амулет»). Всплывает над прицелом и
// гаснет; несколько подряд встают столбиком. Разметка и стили — здесь,
// index.html не трогаем.

const STYLE = `
#artifact-toasts {
  position: fixed;
  left: 50%;
  top: 58%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: 6px;
  z-index: 7;
  pointer-events: none;
  font-family: var(--font-game, monospace);
  user-select: none;
}
#artifact-toasts .atoast {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 14px 6px 8px;
  background: rgba(14, 10, 16, 0.72);
  border: 1px solid rgba(var(--ac), 0.75);
  box-shadow: 0 0 18px rgba(var(--ac), 0.45), inset 0 0 10px rgba(var(--ac), 0.18);
  animation: atoast-in 2.6s ease-out forwards;
  white-space: nowrap;
}
#artifact-toasts .atoast img {
  width: 44px; height: 44px;
  image-rendering: pixelated;
  filter: drop-shadow(0 0 6px rgba(var(--ac), 0.9));
}
#artifact-toasts .atoast .amain {
  font-size: 22px;
  color: rgb(var(--ac));
  text-shadow: 0 0 8px rgba(var(--ac), 0.8), 0 2px 0 #000;
  letter-spacing: 0.02em;
}
#artifact-toasts .atoast .asub {
  font-size: 12px;
  color: #d8cbb4;
  text-shadow: 0 1px 0 #000;
  margin-top: 1px;
}
#artifact-toasts .atoast.relic .amain { font-size: 26px; }
@keyframes atoast-in {
  0%   { opacity: 0; transform: translateY(18px) scale(0.85); }
  8%   { opacity: 1; transform: translateY(0) scale(1.06); }
  14%  { transform: translateY(0) scale(1); }
  75%  { opacity: 1; transform: translateY(-10px); }
  100% { opacity: 0; transform: translateY(-34px); }
}
@media (max-width: 640px), (max-height: 500px) {
  #artifact-toasts { top: 53%; }
  #artifact-toasts .atoast .amain { font-size: 18px; }
  #artifact-toasts .atoast.relic .amain { font-size: 21px; }
  #artifact-toasts .atoast img { width: 34px; height: 34px; }
}
`;

const MAX_TOASTS = 3;
const LIFE_MS = 2600;

export interface ToastSpec {
  icon: string;
  main: string;
  sub: string;
  /** Цвет рамки и текста, 0..1. */
  color: [number, number, number];
  relic: boolean;
}

export class ArtifactToasts {
  private root: HTMLDivElement;

  constructor() {
    if (!document.getElementById("artifact-toasts-style")) {
      const st = document.createElement("style");
      st.id = "artifact-toasts-style";
      st.textContent = STYLE;
      document.head.appendChild(st);
    }
    this.root = document.createElement("div");
    this.root.id = "artifact-toasts";
    document.body.appendChild(this.root);
  }

  show(t: ToastSpec): void {
    while (this.root.childElementCount >= MAX_TOASTS) this.root.firstElementChild?.remove();
    const el = document.createElement("div");
    el.className = "atoast" + (t.relic ? " relic" : "");
    const c = t.color.map((v) => Math.round(Math.min(1, v * 0.75 + 0.25) * 255)).join(", ");
    el.style.setProperty("--ac", c);
    if (t.icon) {
      const img = document.createElement("img");
      img.src = t.icon;
      img.alt = "";
      el.appendChild(img);
    }
    const txt = document.createElement("div");
    const main = document.createElement("div");
    main.className = "amain";
    main.textContent = t.main;
    const sub = document.createElement("div");
    sub.className = "asub";
    sub.textContent = t.sub;
    txt.append(main, sub);
    el.appendChild(txt);
    this.root.appendChild(el);
    window.setTimeout(() => el.remove(), LIFE_MS + 50);
  }

  clear(): void {
    this.root.replaceChildren();
  }
}
